<div class="m-0 head form-step--headerwrapper common-header-hide" *ngIf="planInfo">
  <!--business-name -->
  <div class="cancel-btns header col-md-8" *ngIf="(planInfo && !onlyCloseButton) && !manual_continue">
    <div class="py-md-3 header-bar1 d-flex align-items-center">
      <div class="header-bar3" [ngClass]="mainService.closePayBtn ? '' : ''">
        <img src="assets/png/arrow-left.png" alt="" class="me-2 d-md-none img_left" (click)="changeScreen()"
          *ngIf="(mainService.current_step !== 1 && mainService.closePayBtn)">
        <img src="assets/png/arrow-left.png" alt="" class="me-2 d-md-none img_left" (click)="goBack()"
          *ngIf="planInfo.is_arv2 == 1 && !mainService.closePayBtn">
        <span class="business-logo-outer mx-auto d-flex justify-content-center align-items-center overflow-hidden"
          (click)="topheaderData()" [ngClass]="{'profileimage': !planInfo.doctor_image}">
          <img *ngIf="planInfo.doctor_image" [src]="planInfo.doctor_image" class="new-img -img-fluid -business-logo"
            alt="Doctor">
          <span class="m-0 h4 practice-name fw-800 color-blue text-uppercase" *ngIf="!planInfo.doctor_image">
            <span><span class="notranslate">
                {{getNamelogo(planInfo && planInfo.practice_name?planInfo &&
                planInfo.practice_name:planInfo.doctor_first_name
                + ' ' + planInfo.doctor_last_name | titlecase)}}

              </span> </span>
          </span>
        </span>
        <p class="m-0 h4 -sidebar-name text-white fw-800 text-capitalize d-md-none d-inline-block ps-3"
          *ngIf="planInfo.practice_name || planInfo.doctor_first_name" (click)="topheaderData()">
          {{planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name + ' ' +
          planInfo.doctor_last_name | titlecase}}
        </p>
      </div>
      <span class="header-expend--icon d-md-none d-block ms-3">
        <svg (click)="topheaderData()" [ngClass]="topHeaderexpend? 'topheaderIcon': ''"
          xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
          <path d="M5.08008 7.8125L11.2676 14L17.4551 7.8125" stroke="#9FD2E2" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
    </div>
    <!-- Mobile Header Dropdown Start-->
    <div class="header-mobileview-expend-data" [ngClass]="topHeaderexpend? 'topheaderbody': ''">
      <div class="header-bar2-contact mt-2 text-center mb-2">
        <p class="mb-0 fw-700"> <img src="assets\png\mail.png" alt="" class="mt-1">
          {{planInfo.practice_email
          || planInfo.doctor_email }}</p>
        <p class="pb-2 mb-0 fs-14 fw-700 mt-0"> <img src="assets\png\call-calling.png" alt="">
          <span>
            <span class="notranslate">
              {{(planInfo.doctor_mobile_country_code || planInfo.practice_mobile_country_code) ?
              (planInfo.practice_mobile_country_code || planInfo.doctor_mobile_country_code) : 'N.A.'}}
              {{(planInfo.doctor_phone || planInfo.practice_mobile || planInfo.doctor_mobile) ?
              (planInfo.practice_mobile ||
              planInfo.doctor_phone) : 'N.A.'}}
            </span>
          </span>
        </p>
      </div>
      <!-- <div class="col-12 block_hello_user_1 d-md-none d-block" *ngIf="planInfo && planInfo.patient_first_name">
        <span class="fs-16 howard fw-400">Hello
          <span class=" text-capitalize howard1 fw-700">{{(planInfo.patient_first_name || '') + ' ' +
            (planInfo.patient_last_name || '') | titlecase }},</span>
        </span>
        <p class="fs-16 mb-0">Please review the proposed payment plan(s) from
          &nbsp;{{planInfo.practice_name ||
          (planInfo.doctor_first_name +
          '' + planInfo.doctor_last_name)}}:
        </p>
      </div> -->
    </div>
    <!-- Mobile Header Dropdown End-->
    <div class="py-2 header-bar2 d-none d-md-block">
      <p class="m-0 h4 sidebar-name text-white fw-800 text-capitalize d-md-inline-block d-none"
        *ngIf="planInfo.practice_name || planInfo.doctor_first_name">
        {{planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name + ' ' +
        planInfo.doctor_last_name | titlecase}}
        <span
          *ngIf="(planInfo.doctor_first_name && planInfo.doctor_first_name.length>20) || (planInfo.practice_name && planInfo.practice_name.length>20)"
          class="tool-tip-value">
          {{planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name + ' ' +
          planInfo.doctor_last_name | titlecase}}
        </span>
      </p>

      <div class="header-bar2-contact mt-2">
        <p class="pb-2 mb-0 fw-700 header-export"> <img src="assets\png\mail.png" alt="" class="mt-1">
          <span>{{planInfo.practice_email
            || planInfo.doctor_email }}</span>
        </p>
        <p class="pb-2 mb-0 fs-14 fw-700 header-export"> <img src="assets\png\call-calling.png" alt="">
          <span>
            <span class="notranslate">
              {{(planInfo.doctor_mobile_country_code || planInfo.practice_mobile_country_code) ?
              (planInfo.practice_mobile_country_code || planInfo.doctor_mobile_country_code) : 'N.A.'}}
              {{(planInfo.doctor_phone || planInfo.practice_mobile || planInfo.doctor_mobile) ?
              (planInfo.practice_mobile ||
              planInfo.doctor_phone) : 'N.A.'}}
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="manual_continue" class="manual_payment">
    <div class="diff_card" (click)="redirectBack()">
      <img src="assets/png/manual_back.png" alt="">
    </div>
    <div class="pay_card">
      <span>{{mainService.current_step == 3 ?"Recurring Details" :mainService.current_step == 4 ? "Make
        Payment":""}}</span>
    </div>
  </div>
  <div class="col-md-4 d-none d-md-block">
    <div class="right_side">
      <div class="right_side_part">
        <p class="amo-plan">
          Payment Plan Amount
        </p>
        <p class="right_side_part_one" *ngIf="planInfo && planInfo.treatment_amount">
          <span class="downpayment">
            <span translate="no">
              {{ mainService.currency_data.display_logo }}
              {{ planInfo?.treatment_amount ?
              ((planInfo.treatment_amount - (planInfo.downpayment_amount || 0)) |
              DynamicDecimalPipe:mainService.currency_data.currency_code)
              : '0.00' }}
            </span>
          </span>
          <span class="info_icon_btn service-amount-btn ps-2">
            <span class="info_icon_btn_img">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                  stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9.375 9.375H10V13.75H10.625" stroke="white" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                  fill="white" />
              </svg>
            </span>
            <!-- <img src="assets\png\Icons.png" alt="" class="info_icon_btn_img"> -->
            <span class="tooltip_box">
              <div class="info_icon_btn_payment">
                <div class="payment_part">
                  <div class="payment_part_down" *ngIf="contract_service_record && contract_service_record.length > 0">
                    <span class="color-gray p-0 m-0"
                      *ngIf="planInfo && planInfo.is_ar_contract == 1 && planInfo.downpayment_amount > 0">Partial
                      Payment</span>
                    <span class="down-amo"
                      *ngIf="planInfo && planInfo.is_ar_contract == 1 && planInfo.downpayment_amount > 0"><span
                        translate="no">{{mainService.currency_data.display_logo}}{{(planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code)}}</span></span>

                    <span class="color-gray p-0 m-0" *ngIf="planInfo && planInfo.is_ar_contract == 0">Down
                      Payment</span>
                    <span class="down-amo" *ngIf="planInfo && planInfo.is_ar_contract == 0"><span
                        translate="no">{{mainService.currency_data.display_logo}}{{(planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code)}}</span></span>

                  </div>
                  <div class="payment_part_down" *ngIf="contract_service_record && contract_service_record.length > 0">
                    <span class="down-label">Service amount:</span>
                    <span class="down-amo"><span
                        translate="no">{{mainService.currency_data.display_logo}}{{planInfo.treatment_amount |
                        DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                    </span>
                  </div>
                  <div class="service-record-wrapper">
                    <div *ngFor="let service of contract_service_record" class=" payment_part_down">
                      <span class="down-label">
                        {{service.service}}</span>
                      <span class="down-amo"><span translate="no"> {{mainService.currency_data.display_logo}}{{service
                          &&
                          service.price | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                    </div>
                  </div>
                </div>

              </div>
            </span>
          </span>
        </p>
      </div>
      <div class="right_side_part1"
        *ngIf="planInfo && ((planInfo.is_ar_contract == 1 || planInfo.enrollment_enabled != 1) && enrollmentFee )">
        <span class="amo-plan1">
          {{((planInfo && planInfo.enrollment_enabled != 1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' :
          planInfo && planInfo.is_ar_contract == 1 ? 'Account Setup Fee:' : ''}}
        </span>

        <div class="amo-plan1-strike">
          <span class="wrong-data me-md-2">
            <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
              translate="no">{{mainService.currency_data.display_logo}}
            </span>
            <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
              [innerText]="mainService.strike_enrollment_fee" translate="no">
            </span>
          </span>
          <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' " class="">
            <span class="notranslate">
              {{mainService.currency_data.display_logo}}{{enrollmentFee}}</span>
          </div>
          <div *ngIf="mainService.promotionalEnrollmentOffer" class="recurring-percent">PROMO
          </div>
        </div>
      </div>
    </div>

    <div class="support d-inline-block">
      <div class="me-3 support-plns position-relative"
        *ngIf="mainService.current_step === 2 || mainService.current_step === 1">
        <!-- <p class="support-cus m-0 info_icon_btn"><img src="assets\png\helpmark.png" alt=""> Help Support</p> -->
        <span class="tooltip_box  color-gray-1 show_divs">
          Contact business if you have any query regarding your payment plan
        </span>
      </div>

    </div>
  </div>
  <!-- Close Button Code -->
  <div *ngIf="planInfo && (onlyCloseButton || profileButtons)" class="w-100">

    <div class="w-100 container_close_button px-3"
      *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) ">
      <span class="align-items-center d-none logo_phone_header" *ngIf="profileButtons">
        <span class="business-logo-outer d-flex align-items-center bg-white overflow-hidden flex-grow-1"
          *ngIf="planInfo && planInfo.doctor_image">
          <img [src]="planInfo.doctor_image" class="img-fluid business-logo" alt="Doctor">
        </span>

        <span class="color-blue fs-24 fw-900 text-uppercase"
          style="width: 48px;height: 48px;border-radius: 50%; background: #DEE8F1;display: flex;align-items: center;justify-content: center;"
          *ngIf="planInfo && !planInfo.doctor_image">
          {{getNamelogo(planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name
          + ' ' + planInfo.doctor_last_name) | titlecase}}
        </span>
        <span
          class="px-3 fw-800 fs-16 text-white text-capitalize">{{planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name
          + ' ' + planInfo.doctor_last_name | titlecase}}</span>
      </span>

      <!-- <button type="button" class="btn rounded-pill bg-white border px-4 py-2 close_button_round" data-toggle="modal"
        data-target="#cancelModal" (click)="confirmCloseModel()" *ngIf="url!='personal-details'"
        [ngStyle]="{'border-color': !buttonWhite ? '#596775' : 'white' }">
        <span class="color-blue fw-700 fs-14">
          Close
        </span>
        <span class="button_cross d-none" [ngStyle]="{'color': !buttonWhite ? 'black' : 'white' }">
          <img src="assets/svg/close-circle.svg" alt="">
        </span>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="16" fill="#F1F1F1" />
          <g opacity="0.8">
            <path d="M21 11L11 21" stroke="#6A6A6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L21 21" stroke="#6A6A6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </g>
        </svg>
      </button> -->
    </div>


  </div>
  <!--Close Button Code  -->
  <div *ngIf="(planInfo && (planInfo.practice_name || planInfo.doctor_first_name)) && !manual_continue"
    class="close-btn close-invoice-btn position-fixed rounded-circle"
    [ngClass]="mainService.current_step > 5 ? d-none: '' " [class.plan-close-btn]="!mainService.closePayBtn"
    [class.payment-detail-btn]="getPaymentUrl == true">
    <button type="button"
      class="btn rounded-circle p-0 close_button_round d-flex align-items-center jusitfy-content-center m-auto"
      data-toggle="modal" data-target="#cancelModal" (click)="confirmCloseModel()"
      *ngIf="(url!='personal-details') && ( mainService.current_step != 5 )"
      [ngClass]="planInfo && planInfo.contract_code  ? 'fivesteps' :'five'">
      <!-- [ngStyle]="{'border-color': !buttonWhite ? '#596775' : 'white' } -->
      <!-- <span class=" fw-700 fs-14" style="color: #0089B3;">
      Close
    </span> -->
      <!-- <img src="../../../../assets/svg/close-circle.svg" alt="close-icon"> -->
      <span class="button_cross" [ngStyle]="{'color': !buttonWhite ? 'black' : 'white' }"
        [ngClass]="mainService.current_step == 5 ? 'fivesteps' :''">
        <img src="assets/svg/close-circle.svg" alt="close-icon" class="close-icon-desktop">
        <!-- <img src="assets/svg/white-close-circle.svg" alt="close-icon" class="d-block d-md-none close-icon-mob"> -->
      </span>
      <!-- <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#F1F1F1" />
      <g opacity="0.8">
        <path d="M21 11L11 21" stroke="#6A6A6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11 11L21 21" stroke="#6A6A6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </svg> -->
    </button>
  </div>
</div>


<!--Personal  Information Custom Header Start -->

<!-- <div class="m-0 personal-info--headerwrapper" *ngIf="!planInfo">
  <div *ngIf="planInfo && !onlyCloseButton">
    <div class="py-md-2 d-flex align-items-center">
      <span class="business-logo-outer mx-auto d-flex justify-content-center align-items-center overflow-hidden">
        <img *ngIf="planInfo.doctor_image &&(!planInfo.practice_name || !planInfo.doctor_last_name)"
          [src]="planInfo.doctor_image" class="img-fluid business-logo" alt="Doctor">
        <span class="m-0 h4 practice-name fw-800 color-blue text-uppercase"
          *ngIf="!planInfo.doctor_image ||(planInfo.practice_name || planInfo.doctor_last_name)">
          <span><span class="notranslate">
              {{getNamelogo(planInfo
              && planInfo.practice_name?planInfo && planInfo.practice_name:planInfo.doctor_first_name
              + ' ' + planInfo.doctor_last_name | titlecase)}}

            </span> </span>
        </span>
      </span>
      <p class="m-0 h4 sidebar-name text-white fw-800 text-capitalize ps-3"
        *ngIf="planInfo.practice_name || planInfo.doctor_first_name">
        {{planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name + ' ' +
        planInfo.doctor_last_name | titlecase}}
      </p>
      <span class="header-expend--icon ms-3">
        <svg (click)="headerExpend()" [ngClass]="headerExpendicon? 'iconrote': ''" xmlns="http://www.w3.org/2000/svg"
          width="23" height="22" viewBox="0 0 23 22" fill="none">
          <path d="M5.08008 7.8125L11.2676 14L17.4551 7.8125" stroke="#9FD2E2" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
    </div>
    <div class="header-mobileview-expend-data" [ngClass]="headerExpendicon? 'expendHeader': ''">
      <div class="personal-info--expendwrapper">
        <div class="left--wrapper">
          <div class="py-2 header-bar2">
            <div class="header-bar2-contact mt-2">
              <p class="pb-2 mb-0 fw-700 header-export"> <img src="assets\png\mail.png" alt="" class="mt-1">
                <span class="ms-1">
                  {{planInfo.practice_email
                  || planInfo.doctor_email }}
                </span>
              </p>
              <p class="pb-2 mb-0 fs-14 fw-700 header-export"> <img src="assets\png\call-calling.png" alt="">
                <span class="notranslatems-1">
                  {{(planInfo.doctor_mobile_country_code || planInfo.practice_mobile_country_code) ?
                  (planInfo.practice_mobile_country_code || planInfo.doctor_mobile_country_code) : 'N.A.'}}
                  {{(planInfo.doctor_phone || planInfo.practice_mobile || planInfo.doctor_mobile) ?
                  (planInfo.practice_mobile ||
                  planInfo.doctor_phone) : 'N.A.'}}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="right--wrapper">
          <div class="right_side">
            <div class="right_side_part">
              <p class="amo-plan fs-14">
                Payment Plan Amount
              </p>
              <div class="d-flex align-items-baseline">
                <p class="right_side_part_one align-items-center d-flex me-2"
                  *ngIf="planInfo && planInfo.treatment_amount">
                  <span class="downpayment">
                    <span translate="no">
                       {{ mainService.currency_data.display_logo }}{{ planInfo?.treatment_amount | DynamicDecimalPipe:mainService.currency_data.currency_code }}
                    </span>
                  </span>
                  <span class="info_icon_btn service-amount-btn ps-2">
                    <span class="info_icon_btn_img">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                          stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.375 9.375H10V13.75H10.625" stroke="white" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                          fill="white" />
                      </svg>
                    </span>
                    <span class="tooltip_box">
                      <div class="info_icon_btn_payment">
                        <div class="payment_part">
                          <div class="payment_part_down"
                            *ngIf="contract_service_record && contract_service_record.length > 0">
                            <span class="down-label">Down payment:</span>
                            <span class="down-amo"><span translate="no">
                                {{mainService.currency_data.display_logo}}{{planInfo.downpayment_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                          </div>
                          <div class="payment_part_down"
                            *ngIf="contract_service_record && contract_service_record.length > 0">
                            <span class="down-label">Service amount:</span>
                            <span class="down-amo"><span
                                translate="no">{{mainService.currency_data.display_logo}}{{planInfo.treatment_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                            </span>
                          </div>
                          <div class="service-record-wrapper ">
                            <div *ngFor="let service of contract_service_record" class="payment_part_down">
                              <span class="down-label" [tooltip]="service.service">
                                {{service.service}}</span>
                              <span class="down-amo"><span translate="no">
                                  {{mainService.currency_data.display_logo}}{{service &&
                                  service.price | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                            </div>
                          </div>
                        </div>

                      </div>
                    </span>
                  </span>
                </p>
                <div class="right_side_part1"
                  *ngIf="planInfo && ((planInfo.is_ar_contract == 1 || planInfo.enrollment_enabled != 1) && enrollmentFee )">
                  <span class="amo-plan1">
                    {{((planInfo && planInfo.enrollment_enabled != 1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' :
                    planInfo && planInfo.is_ar_contract == 1 ? 'Account Setup Fee:' : ''}}
                  </span>

                  <div class="amo-plan1-strike">
                    <span class="wrong-data me-md-2">
                      <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                        translate="no">{{mainService.currency_data.display_logo}}
                      </span>
                      <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                        [innerText]="mainService.strike_enrollment_fee" translate="no">
                      </span>
                    </span>
                    <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' " class="">
                      <span class="notranslate">
                        {{mainService.currency_data.display_logo}}{{enrollmentFee ? enrollmentFee: '30'}}</span>
                    </div>
                    <div *ngIf="mainService.promotionalEnrollmentOffer" class="recurring-percent">PROMO
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="support d-inline-block">
            <div class="me-3 support-plns position-relative"
              *ngIf="mainService.current_step === 2 || mainService.current_step === 1">
              <span class="tooltip_box  color-gray-1 show_divs">
                Contact business if you have any query regarding your payment plan
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>


  <div *ngIf="planInfo && (onlyCloseButton || profileButtons)" class="w-100">

    <div class="w-100 container_close_button px-3"
      *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) ">
      <span class="align-items-center d-none logo_phone_header" *ngIf="profileButtons">
        <span class="business-logo-outer d-flex align-items-center bg-white overflow-hidden flex-grow-1"
          *ngIf="planInfo && planInfo.doctor_image">
          <img [src]="planInfo.doctor_image" class="img-fluid business-logo" alt="Doctor">
        </span>

        <span class="color-blue fs-24 fw-900 text-uppercase"
          style="width: 48px;height: 48px;border-radius: 50%; background: #DEE8F1;display: flex;align-items: center;justify-content: center;"
          *ngIf="planInfo && !planInfo.doctor_image">
          {{getNamelogo(planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name
          + ' ' + planInfo.doctor_last_name) | titlecase}}
        </span>
        <span
          class="px-3 fw-800 fs-16 text-white text-capitalize">{{planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name
          + ' ' + planInfo.doctor_last_name | titlecase}}</span>
      </span>
    </div>


  </div>
  <div *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name)"
    class="close-btn close-invoice-btn position-fixed rounded-circle"
    [ngClass]="mainService.current_step == 5 ? 'd-block': '' " [class.plan-close-btn]="!mainService.closePayBtn"
    [class.payment-detail-btn]="getPaymentUrl == true">
    <button type="button"
      class="btn rounded-circle p-0 close_button_round d-flex align-items-center jusitfy-content-center m-auto"
      data-toggle="modal" data-target="#cancelModal" (click)="confirmCloseModel()"
      *ngIf="( mainService.current_step != 7 )" [ngClass]="planInfo && planInfo.contract_code  ? 'fivesteps' :'five'">
      <span class="button_cross" [ngStyle]="{'color': !buttonWhite ? 'black' : 'white' }"
        [ngClass]="mainService.current_step == 5 ? 'fivesteps' :''">
        <img src="assets/svg/close-circle.svg" alt="close-icon" class="close-icon-desktop">
      </span>
    </button>
  </div>
</div> -->
<!-- Personal Information Custom Header End -->


<p class="font-weight-bold h5 px-2 py-2 steps-outer d-none"
  *ngIf="(!(planInfo && planInfo.request_from == 1) && url != 'plans') && !onlyCloseButton">
  <button class="rounded-circle btn btn-secondary me-2" *ngIf="previousRoute" (click)="mainService.back()">
    <i class="fa fa-chevron-left"></i>
  </button>
  <!-- <span [ngClass]="{'link-primary':url == 'plans'}">1. Select Payment Plan</span>
  <i class="fa fa-chevron-right mx-2"></i>

  <span [ngClass]="{'link-primary':url == 'payment-details'}">2. Add Payment Details</span>
  <i class="fa fa-chevron-right mx-2"></i> 

  <span [ngClass]="{'link-primary':url == 'personal-details'}">3. Add Personal Details</span> -->
</p>

<div bsModal #cancelModal="bs-modal" [config]="{ignoreBackdropClick:false}" backdrop="false" class="modal modal_plan"
  tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" aria-modal="true">
  <div class="modal-dialog modal-md modal-dialog-centered customModal cancelModal justify-content-center">
    <div class="modal-content address p-3" style="max-width: 600px !important;">
      <div class="d-flex align-items-center justify-content-between p-3">
        <h4 class="modal-title text-center">
          <span class="pull-left text-start color-black fs-18 fw-900">Confirm To Close</span>
          <!-- <svg class="mt-2 pull-right" (click)="cancelModal.hide()" width="18" height="18" viewBox="0 0 18 18"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 17L1 1M17 1L1 17" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg> -->
        </h4>
        <span class="bg-white color-dblue rounded-circle border px-3 py-2 fs-16" role="button_close"
          (click)="cancelModal.hide()">
          <img src="assets/svg/close-circle.svg" alt="">
        </span>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12" *ngIf="step == 1">
            <div class="row pt-md-2 pb-md-5">
              <div class="col-12 col-sm-6 mb-sm-0 mb-3" (click)="remindLater()" (keyup.enter)="remindLater()"
                tabindex="1">
                <div class="py-md-5 py-4" style="background-color: #F6F6F6; border-radius: 16px;">
                  <span class="d-block text-center">
                    <span class="d-inline-block p-md-4 p-2 rounded">
                      <!-- <svg width="42" height="39" viewBox="0 0 42 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.32118 0.53518L8.32114 0.535184C6.24856 0.751583 4.34977 1.68562 2.91476 3.19435L2.91476 3.19435C1.55774 4.62106 0.728743 6.44026 0.539304 8.40917L0.539304 8.40918C0.322364 10.6635 1.01043 12.9636 2.43239 14.7348C2.67569 15.0379 3.43728 15.8077 3.7158 16.0335L3.41471 16.4049L3.71581 16.0335L3.88428 16.17L4.10795 16.3514L4.06339 16.6358L3.96994 17.2323C3.96994 17.2323 3.96994 17.2323 3.96994 17.2324C3.57495 19.7543 3.6766 22.1238 4.27621 24.4683L3.79426 24.5915L4.27621 24.4683C4.99551 27.2808 6.5162 30.0507 8.41074 32.0145L8.06497 32.3481L8.41075 32.0145L8.73408 32.3496L9.07286 32.7008L8.73006 33.0481L6.88306 34.919L6.79483 35.0084C5.76696 36.0495 5.30096 36.5215 5.07866 36.8191C4.97628 36.9561 4.9562 37.0178 4.94792 37.0538C4.93469 37.1112 4.93452 37.1693 4.93394 37.3667L4.93393 37.3711C4.93334 37.5698 4.93767 37.6277 4.94503 37.6648C4.94993 37.6894 4.9581 37.7181 5.02245 37.85L4.57307 38.0692L5.02245 37.85C5.25739 38.3316 5.7631 38.5746 6.2202 38.4793L6.22023 38.4793C6.34826 38.4526 6.39608 38.4395 6.44662 38.4158C6.49891 38.3913 6.57871 38.3429 6.72887 38.2158C7.04018 37.9524 7.54461 37.4476 8.5815 36.4047L10.5129 34.4621L10.8134 34.1598L11.1594 34.4088L11.3928 34.5766C11.7937 34.865 12.68 35.3843 13.3806 35.7367C16.634 37.3731 20.3019 37.9099 23.9813 37.2834C24.5434 37.1877 25.7955 36.8706 26.3712 36.6777L26.5147 37.1059L26.3712 36.6777C27.7766 36.2068 29.1703 35.5297 30.3984 34.7216C30.5361 34.6311 30.666 34.5478 30.7652 34.4864C30.8142 34.456 30.8589 34.429 30.8944 34.4085C30.9114 34.3988 30.9318 34.3873 30.9519 34.3771C30.9586 34.3738 30.9689 34.3686 30.9817 34.3629C30.9869 34.3606 30.9924 34.3582 30.9983 34.3558C31.0082 34.3517 31.0261 34.3446 31.0487 34.3379L31.0493 34.3377C31.0635 34.3335 31.1201 34.3165 31.194 34.3165C31.3062 34.3165 31.3879 34.3554 31.4011 34.3614C31.4295 34.3742 31.4507 34.3871 31.4607 34.3934C31.4818 34.4066 31.4976 34.4187 31.5038 34.4234C31.5182 34.4345 31.5302 34.445 31.5364 34.4504C31.5506 34.4629 31.5665 34.4775 31.5815 34.4916C31.6127 34.5208 31.6552 34.5618 31.7065 34.6117C31.8098 34.7122 31.956 34.8565 32.1337 35.0331C32.4895 35.3867 32.9755 35.8738 33.5059 36.4091L33.608 36.5122C34.6654 37.5795 35.148 38.0666 35.4493 38.2993C35.5902 38.4082 35.6507 38.4277 35.6815 38.4352C35.7333 38.4476 35.7837 38.4476 35.9812 38.4476H35.9819C36.1453 38.4476 36.2105 38.4426 36.252 38.435C36.2811 38.4297 36.3115 38.4212 36.3972 38.3806C36.6351 38.268 36.8211 38.0842 36.9364 37.8479C36.9973 37.723 37.0074 37.69 37.0126 37.6652C37.0192 37.6337 37.0241 37.5839 37.0233 37.4153C37.0222 37.1767 37.0035 37.0907 36.9549 36.965L36.9549 36.965C36.9541 36.963 36.9534 36.961 36.9526 36.9589C36.9408 36.9267 36.9217 36.8745 36.6876 36.6182C36.4346 36.3412 35.9775 35.8749 35.1094 34.9946L33.2538 33.1129L32.9214 32.7758L33.2399 32.4255L33.6725 31.9496L33.9933 32.2413L33.6725 31.9496C35.6934 29.7269 37.0835 27.1156 37.7836 24.2299C38.3294 21.9802 38.4124 19.6686 38.0303 17.2296L37.9365 16.6304L37.8922 16.3478L38.1134 16.1664L38.3037 16.0103C38.3037 16.0103 38.3037 16.0103 38.3037 16.0103C38.3913 15.9384 38.6357 15.7144 38.8438 15.5126L39.1827 15.8619L38.8438 15.5125C41.2375 13.1906 42.0983 9.74012 41.0772 6.54872L41.5534 6.39635L41.0772 6.54872C40.1601 3.68218 37.8501 1.50514 34.9341 0.759211C32.0687 0.0262527 28.9644 0.873614 26.8355 2.97532L26.8355 2.97533L26.511 3.29561L26.3077 3.49629L26.0316 3.42307L25.4559 3.27042C25.4559 3.27042 25.4559 3.27042 25.4559 3.27042C22.5011 2.4871 19.4097 2.48824 16.5601 3.26933L16.4422 2.83917L16.5601 3.26933L15.9855 3.42683L15.7107 3.50217L15.5058 3.30408L15.1537 2.96364L15.1537 2.96362C13.825 1.67876 12.2192 0.87426 10.4301 0.59326L8.32118 0.53518ZM8.32118 0.53518C8.5356 0.512774 8.94095 0.507235 9.3714 0.519049M8.32118 0.53518L9.3714 0.519049M10.6472 2.94151L10.6472 2.94151C11.3575 3.12329 12.1827 3.47932 12.687 3.83649L12.687 3.83654L12.8078 3.92211L13.435 4.36651L12.7745 4.75971L12.2894 5.04849M10.6472 2.94151L12.2894 5.04849M10.6472 2.94151C10.2193 2.83202 9.99857 2.81345 9.28597 2.80007C8.23356 2.78027 7.65823 2.87156 6.80349 3.2124L6.80348 3.21241C5.07954 3.8999 3.6957 5.3503 3.08724 7.10646L3.08724 7.10647C2.63244 8.41916 2.62437 9.96178 3.06678 11.2714L3.06678 11.2715C3.27932 11.9005 3.75912 12.7904 4.14346 13.2514C4.14347 13.2514 4.14348 13.2514 4.14349 13.2514M10.6472 2.94151L4.14349 13.2514M12.2894 5.04849C10.9922 5.82071 9.86432 6.70387 8.79577 7.78442L8.79577 7.78443C7.41585 9.17978 6.4431 10.5459 5.53861 12.3617L5.53861 12.3617L5.08072 13.2809L4.73935 13.9661L4.24913 13.3781L4.14349 13.2514M12.2894 5.04849L4.14349 13.2514M37.259 13.9922L36.9139 13.2846L36.5166 12.4698C35.0075 9.37549 32.7412 6.88319 29.8657 5.14972C29.6884 5.04285 29.5264 4.94068 29.4076 4.86134C29.3494 4.82252 29.295 4.78484 29.2529 4.75274C29.2341 4.73841 29.2048 4.71551 29.1767 4.68869C29.1657 4.67813 29.1337 4.64729 29.1029 4.60256C29.0886 4.58186 29.0556 4.53151 29.034 4.45919C29.013 4.3892 28.9822 4.22381 29.0862 4.05336C29.0864 4.05308 29.0866 4.0528 29.0867 4.05252L29.513 4.31381L37.259 13.9922ZM37.259 13.9922L37.7528 13.379M37.259 13.9922L37.7528 13.379M37.7528 13.379L37.9038 13.1914C38.3204 12.674 38.719 11.9241 38.9448 11.245C39.4778 9.64291 39.3273 7.75619 38.5469 6.2603C37.6015 4.44812 35.9118 3.20508 33.9096 2.85271L37.7528 13.379ZM30.1093 8.67161L30.4234 8.28254C31.0576 8.79448 32.2188 9.96632 32.726 10.6062C35.4108 13.9936 36.5295 18.3262 35.8279 22.6122C34.7855 28.9799 29.7991 34.0151 23.483 35.0673C19.2236 35.777 14.9624 34.6547 11.5781 31.9345L11.8914 31.5448L11.5781 31.9345C10.9463 31.4266 9.7843 30.2547 9.27472 29.6118C8.49022 28.622 7.75673 27.4062 7.25513 26.2637L7.25512 26.2637C5.71709 22.76 5.54906 18.7793 6.78602 15.1553C7.33312 13.5523 8.21084 11.9485 9.27471 10.6062L9.6186 10.8788L9.27471 10.6062C9.78187 9.96632 10.9431 8.79448 11.5773 8.28254C13.5914 6.65689 15.9899 5.57375 18.5172 5.1502C18.8881 5.08803 19.3839 5.01873 19.6254 4.99635L30.1093 8.67161ZM30.1093 8.67161L30.4234 8.28254C28.0955 6.40361 25.2696 5.26039 22.2884 4.99148L30.1093 8.67161ZM28.7488 19.0027C29.475 19.1583 29.8562 19.9373 29.5292 20.6118L29.5292 20.6118C29.3845 20.9102 29.1026 21.1347 28.7635 21.212C28.7595 21.2121 28.7375 21.2142 28.687 21.2168C28.6202 21.2202 28.5275 21.2236 28.4107 21.2267C28.1777 21.233 27.8594 21.2383 27.4827 21.2426C26.7301 21.2511 25.7517 21.2554 24.7725 21.2554C23.7934 21.2554 22.815 21.2511 22.0624 21.2426C21.6857 21.2383 21.3674 21.233 21.1344 21.2267C21.0176 21.2236 20.9249 21.2202 20.8581 21.2168C20.8075 21.2142 20.7855 21.2121 20.7815 21.212C20.3411 21.112 20.0134 20.784 19.9126 20.3343C19.9123 20.3291 19.9105 20.3076 19.9082 20.2612C19.9051 20.1957 19.9021 20.1044 19.8991 19.9892C19.8933 19.7593 19.8883 19.4441 19.8842 19.0705C19.876 18.3238 19.8714 17.3504 19.8705 16.3735C19.8697 15.3967 19.8727 14.4181 19.8797 13.661C19.8832 13.2822 19.8876 12.9605 19.8931 12.7227C19.8958 12.6035 19.8987 12.5076 19.9018 12.4371C19.9039 12.3887 19.9057 12.3618 19.9065 12.35C19.907 12.3421 19.9071 12.341 19.9065 12.3448C19.9869 11.8515 20.3489 11.475 20.7775 11.3831L20.7776 11.3831C20.7775 11.3831 20.7776 11.3831 20.7776 11.3831C20.7781 11.383 20.7813 11.3824 20.7876 11.3814C20.7947 11.3804 20.8039 11.3792 20.8154 11.3779C20.8385 11.3755 20.8669 11.3733 20.8985 11.3718C20.9632 11.3687 21.0288 11.3689 21.0776 11.3722C21.4993 11.4 21.8627 11.6531 22.0617 12.1212C22.0618 12.1214 22.0619 12.1216 22.0622 12.1218C22.0656 12.1249 22.086 12.1434 22.0979 12.5512C22.1103 12.9788 22.114 13.764 22.1199 15.2985L22.1319 18.4671L22.1338 18.9652H22.6319H25.6291C26.6565 18.9652 27.4205 18.969 27.9462 18.9769C28.2094 18.9809 28.4099 18.9859 28.5525 18.9917C28.6617 18.9962 28.718 19.0008 28.7396 19.0025C28.7502 19.0034 28.7525 19.0036 28.7488 19.0027ZM28.7488 19.0027C28.7487 19.0027 28.7487 19.0027 28.7487 19.0027L28.8515 18.5226L28.7488 19.0027ZM9.3714 0.519049C9.80129 0.530849 10.2098 0.558676 10.4301 0.593257L9.3714 0.519049Z"
                      fill="#1581E5" stroke="#1581E5" />
                  </svg> -->
                      <img src="assets\logos\bell.svg" alt="">
                    </span>
                  </span>
                  <span class="mt-3 h5 d-block text-center fw-700">Remind me later</span>
                </div>
              </div>
              <div class="col-12 col-sm-6" (click)="step=2" (keyup.enter)="step=2" tabindex="2">
                <div class="py-md-5 py-4" style="background-color: #F6F6F6; border-radius: 16px">
                  <span class="d-block text-center">
                    <span class="d-inline-block p-md-4 p-2 rounded">
                      <!-- <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.3038 13.107L14.3039 13.107C14.6324 12.9983 15.0272 12.978 15.3929 13.0112C15.7618 13.0447 16.1519 13.1372 16.4755 13.2953L16.4756 13.2953C18.6839 14.3746 18.6623 17.5925 16.4596 18.673C16.2557 18.7731 16.0752 18.8494 15.8586 18.8932C15.6503 18.9354 15.4328 18.9425 15.164 18.9416C14.7127 18.9402 14.3134 18.8816 13.9413 18.7215C13.5675 18.5606 13.2578 18.3133 12.9617 17.9896L14.3038 13.107ZM14.3038 13.107C14.0164 13.2022 13.7749 13.304 13.5482 13.4517M14.3038 13.107L13.5482 13.4517M20.2942 27.8674L20.1187 27.3992C23.3655 26.1822 26.2627 25.1016 26.5492 25.0011M20.2942 27.8674L27.4194 25.3374L27.5273 24.8492C27.5273 24.8491 27.5272 24.8491 27.5271 24.8491C27.4271 24.827 27.3288 24.8307 27.2655 24.8355C27.1924 24.841 27.1149 24.8525 27.0389 24.8671C26.8867 24.8964 26.7144 24.943 26.5492 25.0011M20.2942 27.8674C23.5456 26.6487 26.4348 25.5711 26.7147 25.4728M20.2942 27.8674L26.7147 25.4728M26.5492 25.0011L26.7147 25.4728M26.5492 25.0011C26.5491 25.0011 26.5491 25.0011 26.549 25.0011L26.7147 25.4728M13.5482 13.4517C13.3211 13.5996 13.1315 13.7787 12.9305 14.002M13.5482 13.4517L12.9305 14.002M12.9305 14.002C11.8931 15.1546 11.9117 16.842 12.9617 17.9896L12.9305 14.002ZM0.601494 18.4514L1.05924 18.5165L0.601493 18.4514C0.531368 18.9446 0.499912 19.9577 0.5 20.9417C0.500088 21.9277 0.5319 22.9537 0.601344 23.476C1.20128 27.99 3.09909 31.9612 6.19306 35.1646C7.95624 36.9902 9.67978 38.2558 11.8909 39.3457C13.9697 40.3704 15.797 40.9503 17.9736 41.2733C23.4648 42.0879 28.9043 40.6933 33.4316 37.3163C33.9436 36.9344 34.739 36.2001 35.4854 35.4543C36.2317 34.7086 36.967 33.9134 37.3501 33.4011C39.5655 30.4377 40.9072 27.1469 41.3967 23.4762C41.4763 22.8799 41.507 21.8554 41.4987 20.8544C41.4903 19.8528 41.4424 18.8228 41.3531 18.2146L40.8584 18.2872L41.3531 18.2146C40.8239 14.6092 39.5083 11.4406 37.3468 8.57135C36.5982 7.5776 34.9084 5.83649 33.9294 5.05001C30.9575 2.66233 27.3791 1.12807 23.6097 0.625655C23.0606 0.552458 22.1225 0.511322 21.2093 0.502033C20.2964 0.492747 19.3616 0.514803 18.8196 0.577063C14.1938 1.10841 10.0961 3.02283 6.80523 6.19523C4.9279 8.00495 3.69749 9.68256 2.57498 11.966C1.55817 14.0343 0.940697 16.0663 0.601494 18.4514ZM31.8187 6.7795L32.1174 6.37852L31.8187 6.77951C32.7852 7.49945 34.5568 9.28343 35.2984 10.2849L35.6372 10.034L35.2984 10.2849C37.2037 12.8578 38.3254 15.6403 38.7538 18.8615C38.8128 19.3047 38.8449 20.1324 38.8449 20.9855C38.8449 21.8386 38.8128 22.6663 38.7538 23.1096C38.2214 27.1128 36.5723 30.5502 33.8339 33.3766C31.525 35.7597 28.6265 37.4627 25.5526 38.2492C22.4778 39.0359 19.52 39.0359 16.4452 38.2492C10.0565 36.6145 4.87874 31.2028 3.53225 24.7536C3.22958 23.3036 3.14754 22.502 3.14754 20.9855C3.14754 19.469 3.22958 18.6675 3.53224 17.2175C4.87872 10.7683 10.0548 5.35816 16.4453 3.7217L16.3373 3.30001L16.4453 3.7217C18.5039 3.19451 20.3856 3.02382 22.3282 3.18346C25.8855 3.47584 28.9333 4.63018 31.8187 6.7795ZM23.8849 16.2077L23.8849 16.2078C23.9553 17.2944 24.5615 18.1939 25.5423 18.6751L25.5424 18.6751C25.7447 18.7743 25.9245 18.85 26.1406 18.8935C26.3482 18.9353 26.5654 18.9425 26.8337 18.9416C27.2851 18.9402 27.6843 18.8816 28.0565 18.7215C28.4303 18.5606 28.74 18.3133 29.0361 17.9896C30.103 16.8235 30.103 15.1363 29.0361 13.9702L29.0361 13.9702C28.2355 13.0952 26.9613 12.7561 25.8582 13.1495C25.234 13.372 24.7472 13.7597 24.3643 14.3236C24.1729 14.6053 24.0343 14.8848 23.9546 15.2025C23.8757 15.5172 23.8613 15.8428 23.8849 16.2077ZM28.1715 27.0759L28.1715 27.0759L13.8292 29.9126C13.8292 29.9126 13.8292 29.9126 13.8292 29.9126C13.3965 30.3097 13.3664 30.8866 13.5348 31.3155C13.7032 31.7443 14.1183 32.1472 14.707 32.1401C14.7853 32.1391 14.8631 32.12 14.8945 32.1123L14.8963 32.1119C14.9443 32.1001 15.0006 32.0842 15.0619 32.0659C15.1852 32.0291 15.3476 31.9767 15.5406 31.9119C15.9277 31.782 16.4533 31.5974 17.0689 31.3763C18.3011 30.9341 19.9034 30.3426 21.4998 29.7431C23.0962 29.1437 24.6888 28.5356 25.9015 28.0599C26.5074 27.8222 27.021 27.6166 27.3934 27.4614C27.5791 27.384 27.7336 27.3175 27.8483 27.2648C27.9052 27.2388 27.9573 27.2138 28.0006 27.1912L28.0039 27.1894C28.0297 27.1759 28.108 27.1352 28.1715 27.0759Z"
                      fill="#1581E5" stroke="#1581E5" />
                  </svg> -->
                      <img src="assets\logos\ntsmiles.svg" alt="">
                    </span>
                  </span>
                  <span class="mt-3 h5 d-block text-center fw-700">Not interested </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 ps-4" *ngIf="step == 2">
            <div class="not-int-points ps-2">
              <div *ngFor="let reasons of reasonList; let i=index">
                <div class="form-check custom-control custom-checkbox not-intrested" (click)="changeReason()"
                  *ngIf="reasons">
                  <input class="form-check-input custom-control-input" type="checkbox" [(ngModel)]="reasons.is_checked"
                    value="" id="reasons-{{reasons.reason_id}}">
                  <label class="form-check-label custom-control-label" for="reasons-{{reasons.reason_id}}">
                    {{reasons.reason_name}}</label>
                </div>
                <div class="ms-5" *ngIf="reasons.childShow">
                  <div class="form-check custom-control custom-checkbox not-intrested"
                    *ngFor="let child of reasons.child; let i=index" (click)="changeReason()">
                    <input class="form-check-input custom-control-input" type="checkbox" [(ngModel)]="child.is_checked"
                      value="" id="child-{{child.reason_id}}">
                    <label class="form-check-label custom-control-label"
                      for="child-{{child.reason_id}}">{{child.reason_name}}</label>
                  </div>
                </div>
              </div>
              <!-- <div class="text-area" ngFor="let context of reasonList; let i = index" *ngIf="reason">
              <p>{{context}}</p>
            </div> -->
              <div class="mt-1  text-start label-head" *ngIf="reasonList[reasonList.length-1].is_checked">
                <textarea class="p-3 w-75" [ngClass]="reasonError && !otherReason ? 'border border-danger':''"
                  [(ngModel)]="otherReason" (keyup)="reasonSent=false"></textarea>
                <label class="textlabel" [ngClass]="{'hidedata': otherReason.length}">Write us your issue, we would like
                  to help you!</label>
              </div>

            </div>
            <div class="mt-3 btn-part">
              <button (click)="cancelModal.hide()" class="ms-1  px-4 p-3 me-2 mb-3 btn-part1"> Back to Payment Plans
                <!-- <svg
                width="15" height="15" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.5L5 9.5L12 16.5" stroke="#30b7c4" stroke-width="1.5" stroke-linecap="round" />
              </svg> -->
              </button>
              <button (click)="sendFeedback();" class="ms-1 px-4 p-3 mb-3 btn-part2">Send &
                Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>